var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, memo, useContext, useRef, useEffect, useCallback, useState } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Sensor from '@max/mbc-sensor';
import './index.scss';
import { fetchData } from './api';
import { parseCityName, parseImageUrl, parsePrice } from './utils';
import ImageCard from './components/ImageCard';
import RouteCard from './components/RouteCard';
const DEFAULT_CITY_ID = 1;
const TrafficTrainTripRecommend = (props) => {
    var _a, _b, _c, _d;
    const initState = {
        hotCitiesList: []
    };
    // 从全局变量global取Context
    const { recommendStrategy, onlyImage, backgroundColor, hotCitiesTitle, hotCitiesTitleColor, maxNumber, hotCityCornerMode, hotCityCornerText, hotCityCornerTextBgColor, hotCityCornerTextColor, hotCityRouteTextColor, hotCityRouteArrowColor, hotCityRouteDurationColor, hotCityRoutePriceBgColor, hotCityRoutePriceTextColor } = props;
    const ctx = useContext(global._EngineGlobalContext);
    const cityId = useRef((_d = (_c = (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.commonParams) === null || _b === void 0 ? void 0 : _b.cityInfo) === null || _c === void 0 ? void 0 : _c.cityId) !== null && _d !== void 0 ? _d : DEFAULT_CITY_ID);
    const [showView, setShowView] = useState(false);
    // // ② 从入口 Props 获取SSR 首屏RPC接口请求数据
    // const cityInfo:any = {};
    // useMemo(() => {
    //   // SSR 首屏初始化
    //   const result = props.apiData?.data;
    //   if (result && result.code === 0) {
    //     if (result.cityId) {
    //       cityInfo.cityId = Number(result.cityId);
    //       // ...
    //     }
    //   }
    // }, []);
    const checkCityChange = (city) => {
        return city.cityId !== cityId.current;
    };
    const [hotCitiesList, setHotCitiesList] = useState(initState.hotCitiesList);
    const getHotCities = () => __awaiter(void 0, void 0, void 0, function* () {
        const reqData = {
            cityId: cityId.current,
            type: recommendStrategy,
            count: maxNumber
        };
        try {
            const hotCitiesListRes = yield fetchData(reqData);
            // console.log('hotCitiesListRes', hotCitiesListRes);
            if ((hotCitiesListRes === null || hotCitiesListRes === void 0 ? void 0 : hotCitiesListRes.length) > 0) {
                hotCitiesListRes === null || hotCitiesListRes === void 0 ? void 0 : hotCitiesListRes.map((city) => {
                    city.priceText = parsePrice(city === null || city === void 0 ? void 0 : city.ticketPrice);
                    city.imageUrl = parseImageUrl(city === null || city === void 0 ? void 0 : city.cityImageUrl);
                    city.toCityNameText = parseCityName(city === null || city === void 0 ? void 0 : city.toCityName);
                    city.fromCityNameText = parseCityName(city === null || city === void 0 ? void 0 : city.fromCityName);
                    city.imageCornerText = hotCityCornerMode === 0 ? hotCityCornerText : city.ticketInsufficient ? '票少' : '';
                });
                setHotCitiesList([...hotCitiesListRes]);
            }
        }
        catch (error) {
            ctx._raptorReport.reportLog('mcp-growth-traffic-train-trip-recommend-请求失败', JSON.stringify(error), {
                category: 'ajaxError',
                level: 'info'
            });
        }
    });
    const onCityChange = useCallback((city) => {
        console.log('监听到城市变化', city);
        if (checkCityChange(city)) {
            cityId.current = city.cityId;
        }
    }, []);
    useEffect(() => {
        var _a;
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.on('traffic-train-select-city-selected', onCityChange);
        return () => {
            var _a;
            (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.off('traffic-train-select-city-selected', onCityChange);
        };
    }, [onCityChange]);
    const init = () => {
        setHotCitiesList([]);
        getHotCities();
    };
    useEffect(() => {
        var _a;
        init();
        const val_lab = {
            custom: {
                component_name: '火车票千人千面组件'
            }
        };
        (_a = ctx._LXReport) === null || _a === void 0 ? void 0 : _a.mvReport('b_daodian_lowcode_609smsx6_mv', {
            valLab: val_lab
        });
    }, []);
    // useEffect(() => {
    //   getHotCities();
    // }, [recommendStrategy, maxNumber]);
    useEffect(() => {
        // console.log('hotCitiesListLengthLi', hotCitiesList);
        if (hotCitiesList.length > 0) {
            // console.log('showView', true);
            setShowView(true);
        }
    }, [hotCitiesList.length]);
    return <View x-if={showView}>
      <Sensor>
        <View className="traffic-train-trip-recommend-container" style={{
        backgroundColor
    }}>
          {(hotCitiesTitle === null || hotCitiesTitle === void 0 ? void 0 : hotCitiesTitle.length) > 0 && <Text className="hot-cities-title" style={{
        color: hotCitiesTitleColor
    }}>
            {hotCitiesTitle}
          </Text>}
          
          <View x-if={onlyImage} className="hot-cities-list-container">
            {(hotCitiesList !== null && hotCitiesList !== void 0 ? hotCitiesList : []).map((city, index) => {
        return <ImageCard city={Object.assign({}, city)} hotCityCornerMode={hotCityCornerMode} hotCityCornerText={hotCityCornerText} hotCityCornerTextBgColor={hotCityCornerTextBgColor} hotCityCornerTextColor={hotCityCornerTextColor} key={index}/>;
    })}
          </View>
          
          <View x-else className="hot-cities-list-container" style={{
        color: hotCityRouteTextColor
    }}>
            <View className="hot-city-route-list">
              {(hotCitiesList !== null && hotCitiesList !== void 0 ? hotCitiesList : []).map((city, index) => {
        return <RouteCard city={Object.assign({}, city)} hotCityRouteArrowColor={hotCityRouteArrowColor} hotCityRouteDurationColor={hotCityRouteDurationColor} hotCityRoutePriceBgColor={hotCityRoutePriceBgColor} hotCityRoutePriceTextColor={hotCityRoutePriceTextColor} backgroundColor={backgroundColor} key={index}/>;
    })}
            </View>
          </View>
        </View>
      </Sensor>
    </View>;
};
export default memo(TrafficTrainTripRecommend);
